class blogSearch extends HTMLElement {
    constructor() {
        super();

        this.init();
    };

    init() {
        this.form = this.querySelector("[js-search-form]");
        this.searchField = this.form.querySelector("[js-search-field]");

        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            const value = this.searchField.value;
            
            const query = this.getQueryUrl(value);

            document.dispatchEvent(new CustomEvent("scroll:init"));
            document.dispatchEvent(new CustomEvent("loading:init", {
                detail: {
                    loading: true
                }
            }));
            this.renderAjaxBlog(query);
        })
    };

    getQueryUrl(query) {
        const url = `/search?type=article&q=*${query}*`;
        return url;
    };

   
    renderAjaxBlog(query) {
        const blogFilter = document.querySelector("[js-blog-filter-list]");
        const currentTagList = document.querySelector("[js-current-tag-list]");
        const blogGrid = document.querySelector("[js-blog-grid]");
        const loadMoreEl = document.querySelector('.js-load-more-btn');
        const filterItem = document.querySelector('[data-tag-handle="all"]');
        const articleCountEl = document.querySelectorAll("[js-article-count]");
        const tagUrl = filterItem.dataset.tagUrl;
        const url = `${query}&view=ajax`;

        document.dispatchEvent(new CustomEvent("updateHistoryState", {
            detail: {
                url: tagUrl
            }
        }));
        
        fetch(url).then(function(response) {
            return response.text();
        }).then((html) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            blogFilter.innerHTML = this.querySelector("[js-blog-filter]").innerHTML;
            currentTagList?.classList.add("hide");
            blogGrid.innerHTML = doc.querySelector("[js-main-search]").innerHTML;
            articleCountEl.forEach( el => el.innerHTML = doc.querySelector("[js-article-count]").innerHTML);
            const loadMore_ = doc.querySelector(".js-load-more-btn");
            if(loadMore_) {
                loadMoreEl.innerHTML = loadMore_.innerHTML;
            }else {
                loadMoreEl.innerHTML = "";
            }

            document.dispatchEvent(new CustomEvent("blog-filter:init"));
            document.dispatchEvent(new CustomEvent("loading:init", {
                detail: {
                    loading: false
                }
            }));
            document.dispatchEvent(new CustomEvent("load-more:init"));
        });
    }
}
    
customElements.define('blog-search', blogSearch);